import { useMemo } from 'react'

import type { UseSamplesOffersQueryOptions } from '../queries/useSamplesOffersQuery'
import { useSamplesOffersQuery } from '../queries/useSamplesOffersQuery'
import { filterOffersWithVariants } from '../utils/filterOffersWithVariants'

type UseSamplesOffersOptions = UseSamplesOffersQueryOptions

export const useSamplesOffers = (options?: UseSamplesOffersOptions) => {
  const { offersQuery } = useSamplesOffersQuery(options)

  const offers = useMemo(
    () => filterOffersWithVariants(offersQuery.data?.offers || []),
    [offersQuery.data],
  )

  return {
    samplesOffers: {
      offers,
      enabled: !!offers.length,
      isLoading: offersQuery.isLoading,
    },
  }
}
